import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'v2/models';
import { PERMISSION_NAME, hasPermission } from 'v2/utils/permissions';
import restFactory from 'v2/utils/restFactory';

export interface IBadgeCounts {
  [name: string]: {
    count?: number;
  };
}

function useGetBadgeCount() {
  const permissions = useSelector(
    (state: RootState) => state.permissions.permissions
  );

  const is_master_reviewer = hasPermission(permissions, [
    PERMISSION_NAME.REVIEW_SEARCH_MASTER_ORG,
  ]);

  const depth = is_master_reviewer ? 'master-organization' : 'organization';

  return useQuery(
    ['get badges counts', depth],
    async () => {
      const response = await restFactory.get<IBadgeCounts>(
        `dj/api/v1/search/badge_count/`,
        {
          depth,
        }
      );

      return response;
    },
    {
      refetchInterval: 30_000,
    }
  );
}

export default useGetBadgeCount;
